<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" color="white">
          <v-icon small class="pr-4">mdi-menu-down</v-icon>Lägg till
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="item.action"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog :value="showCreateManually" width="600" persistent>
      <TrainDeviationCreateModal
        v-if="showCreateManually"
        @close="showCreateManually = false"
      />
    </v-dialog>

    <v-dialog :value="showTrainDeviationFromTraind" width="1000" persistent>
      <TrainDeviationImportFromTraind
        v-if="showTrainDeviationFromTraind"
        @close="showTrainDeviationFromTraind = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import TrainDeviationCreateModal from './TrainDeviationCreateModal'
import TrainDeviationImportFromTraind from './TrainDeviationImportFromTraind'

export default {
  name: 'TrainDeviationCreateDropdown',

  components: {
    TrainDeviationCreateModal,
    TrainDeviationImportFromTraind
  },

  data: () => ({
    showCreateManually: false,
    showTrainDeviationFromTraind: false
  }),

  computed: {
    items() {
      return [
        {
          title: 'Manuellt',
          action: () => {
            this.showCreateManually = true
          }
        },
        {
          title: 'Från Traind',
          action: () => {
            this.showTrainDeviationFromTraind = true
          }
        }
      ]
    }
  }
}
</script>
